<template>
  <!-- Region mismatch · non-blocking advisory. A heads-up that the chosen
       registries don't all match the selected certificates — deliberately
       ochre with a distinct info icon, set apart from the red validation
       errors so it never reads as "you did something wrong". Margin is left
       to the caller (class fallthrough) since each placement spaces differently. -->
  <div class="advisory-note">
    <FontAwesomeIcon
      :icon="['far', 'circle-info']"
      class="flex-shrink-0 mt-1"
    />
    <div>
      <div class="fw-semibold">
        {{ t("go_cancel.region_mismatch_warning.title") }}
      </div>
      <div class="small mb-0">
        {{ t("go_cancel.region_mismatch_warning.message") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
